import type { SVGProps } from "react";
export interface StomachIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StomachIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StomachIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.875 12A6.375 6.375 0 0 0 12.5 5.626c-.422 0-.837.074-1.27.211l-.44.16a2.126 2.126 0 0 1-2.916-1.973V2a1.125 1.125 0 0 1 2.25 0v1.841c.73-.275 1.513-.466 2.376-.466A8.625 8.625 0 0 1 21.125 12c0 4.49-3.206 8.625-8.143 8.625-1.264 0-2.277.72-3.017 1.953l-.065.097a1.126 1.126 0 0 1-1.864-1.254l.196-.31c1.021-1.537 2.604-2.735 4.75-2.736 3.462 0 5.893-2.883 5.893-6.374Zm-15-8.553V2a1.125 1.125 0 0 1 2.25 0v1.447c0 1.634.68 3.194 1.877 4.305l1.586 1.474a5.125 5.125 0 0 1-.023 7.532c-1.337 1.226-2.51 2.293-3.353 3.65l-.164.276-1.071 1.874a1.125 1.125 0 0 1-1.954-1.117l1.07-1.873.204-.341c1.044-1.68 2.461-2.948 3.747-4.127l.217-.221a2.876 2.876 0 0 0-.204-4.005L6.471 9.402a8.13 8.13 0 0 1-2.596-5.955"
      />
      <path
        fill={color}
        d="M13.219 7.41a1.126 1.126 0 0 1 1.336.699l.035.11.108.334c.295.74.869 1.22 1.477 1.336l.035.006.113.027a1.125 1.125 0 0 1-.42 2.2l-.114-.017-.035-.007c-1.59-.303-2.771-1.53-3.256-3.016l-.088-.3-.022-.115a1.125 1.125 0 0 1 .83-1.257Z"
      />
    </svg>
  );
}
